import { render } from "./Button.vue?vue&type=template&id=54f11dce&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-54f11dce"

export default script